var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallsUpdates = function SvgCallsUpdates(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    fill: "#FFE4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65117 10.3123C7.78437 11.3041 8.30577 13.5835 10.3614 15.6391C12.417 17.6947 14.6958 18.2161 15.6882 18.3493C16.407 18.5047 17.1864 18.3073 17.745 17.7487C18.6186 16.8751 15.4542 13.7107 14.5806 14.5843L14.0232 15.1417L10.8588 11.9773L11.4156 11.4199C12.2892 10.5463 9.12477 7.38189 8.25117 8.25549C7.69257 8.81409 7.49517 9.59349 7.65117 10.3123Z",
    fill: "#5A6367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25293 8.25308L11.4167 11.4169C12.2885 10.5427 12.2885 9.12788 11.4149 8.25428C10.5425 7.38188 9.12713 7.38128 8.25293 8.25308Z",
    fill: "#C5C5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.582 14.5822L17.7458 17.746C18.6176 16.8724 18.6176 15.457 17.744 14.5834C16.871 13.711 15.4562 13.7104 14.582 14.5822Z",
    fill: "#C5C5CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5616 11.8724C18.387 12.047 18.1152 12.1022 17.8794 11.99C17.58 11.8472 17.4528 11.4902 17.595 11.1902C17.9772 10.3874 17.8152 9.42923 17.193 8.80703C16.5708 8.18483 15.6126 8.02343 14.8098 8.40503C14.5104 8.54723 14.1528 8.42003 14.01 8.12063C13.8672 7.82123 13.9956 7.46303 14.2944 7.32083C15.555 6.72143 17.061 6.97763 18.0414 7.95803C19.0218 8.93843 19.278 10.4444 18.6786 11.705C18.6492 11.7692 18.609 11.825 18.5616 11.8724Z",
    fill: "#5A6367"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3997 11.7994C16.0624 11.7994 16.5997 11.2622 16.5997 10.5994C16.5997 9.93667 16.0624 9.39941 15.3997 9.39941C14.737 9.39941 14.1997 9.93667 14.1997 10.5994C14.1997 11.2622 14.737 11.7994 15.3997 11.7994Z",
    fill: "#5A6367"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    stroke: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallsUpdates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calls-updates.61b58598ae7ef378bd5ab2c4bc4e7c3f.svg";